import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Payment } from 'models/PaymentModel';


const PaymentList: React.FC = () => {
  const width = { receipt: 10, client: 14, amount: 10, date: 10, segment:10, mop:10, insurer:10, receiveby: 10, refno: 10 }
  const [formId, formName] = [Code.Form.Id.PAYMENT, Code.Form.Name.PAYMENT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [paymentData, setPaymentData] = useState<Payment[]>([]); 
  const [selectedPayment, setselectedPayment] = useState<Payment | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [modeId, setModeId] = useState<number>(Code.Option.Common.ALL);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const [mopOptions, setMopOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, userId, modeId];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();   
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.API(Code.File.MOP, Code.Option.Common.ALL, setMopOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Payment.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Payment.Id, 
        Name.Payment.Number, 
        Name.Payment.Date, 
        Name.Payment.Amount, 
        Name.Common.ModeName, 
        Name.User.FullName, 
        Name.Client.FullName, 
        Name.Client.Id, 
        Name.Insurer.Name, 
        Name.Common.SegmentName, 
        Name.Common.RefNo
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(userId != 1 && { user_id: userId }),
      ...(modeId != 1 && { mode_id: modeId }),
    });
     
    await API.Data.List<Payment>(url, setPaymentData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              {/* <Control.Dropdown title={Title.Role} options={userOptions} onChange={(value) => { setUserId(value);  callListData();  }} /> */}
              <Control.Dropdown title={Title.Created} value={userId} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.Mode} value={modeId} options={mopOptions} onChange={setModeId} />
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, paymentData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Receipt, width.receipt],
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT], 
                [Title.Date, width.date],
                [Title.Segment, width.segment], 
                [Title.MOP, width.mop],
                [Title.Insurer, width.insurer], 
                [Title.ReceivedBy, width.receiveby], 
                [Title.Refno, width.refno],
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(paymentData) && (
              <Control.Grid.Row>
                {paymentData.map((paymentData) => { return (
                <Control.Grid.Data<Payment> key={paymentData.payment_id} itemKey={paymentData.payment_key} data={paymentData} setMenuPosition={setMenuPosition} setSelectedData={setselectedPayment} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={paymentData.payment_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, paymentData.payment_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Text value={paymentData.payment_number} width={width.receipt}  /> 
                  <Control.Grid.Link value={Utility.Get.FullName(paymentData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PrivClient, Code.Form.Name.CLIENT, paymentData.client_id)} width={width.client} iframeRef={iframeRef} /> 
                  <Control.Grid.Items values={[
                    [Utility.Format.Amount(paymentData.payment_amount), width.amount, Code.Align.RIGHT],
                    [Utility.Format.DateOnly(paymentData.payment_date), width.date],
                    [paymentData.segment_name, width.segment],
                    [paymentData.mode_name, width.mop],
                    [paymentData.insurer_name, width.insurer],
                    [paymentData.user_first_name, width.receiveby],
                    [paymentData.payment_ref_number, width.refno],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={paymentData.payment_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={paymentData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedPayment?.payment_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedPayment?.payment_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default PaymentList;